import React from "react";

const PremiumPlusInterior = () => {
  return (
    <div>
      <div>
        <p className="mt-2 mb-2 font-bold">Premium Plus Interior Cleaning</p>
        <ul className="list-disc text-black-500 ">
        <li className="font-bold">DashBoard & Interior Premium Polish</li>
        <li className="font-bold">Free Paper Mat</li>
        <li className="font-bold">Free Air Freshener</li>
        <li className="font-bold">Interior Vacuum Cleaning</li>
          <li className="font-bold">Seat Cleaning</li>
          <li className="font-bold">Carpet & Floor Mat Cleaning</li>
        </ul>
      </div>
    </div>
  );
};

export default PremiumPlusInterior;

